/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ApplySpaceTemplate,
  EntityId,
  Expression,
  Icon,
  List,
  LocalizedString128,
  LocalizedString256,
  SiteSection,
  SiteSectionDescription,
  SiteSectionMovePosition,
  SiteSectionPath,
  SiteSectionTitle,
  SubscriptionNotice,
} from "./data-contracts";

/**
 * @description Creates a new top-level navigation section in the site. The section appears as a tab or sidebar entry in the site navigation. Pass an existing space ID to link it as the section's primary content source, or pass `null` to create and link a new space. New spaces start with a blank page unless a template is provided or `empty` is `true`, which creates the space with no page at all (use it when you are about to add the pages yourself).
 * @tags site-sections
 * @name AddSectionToSite
 * @summary Add a new navigation section to a site backed by a space
 * @request POST:/orgs/{organizationId}/sites/{siteId}/sections
 * @secure
 */

// @ts-ignore
export const addSectionToSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Pass the ID of an existing space or pass `null` to create a new space. The space will be added to the section as a site space variant. */
    spaceId: string | null;
    /** Template for the new space when `spaceId` is `null`. Templates that provision organization-level resources, such as OpenAPI specifications, are not supported by this site-scoped operation. */
    template?: ApplySpaceTemplate;
    /**
     * Create the new space without any content, not even a blank page. Useful when the content is about to be populated, for example by an import. Only valid when `spaceId` is `null` and no template is provided.
     * @default false
     */
    empty?: boolean;
    /** Section title. Also used as the space title when `spaceId` is `null` and no template is provided. */
    title?: SiteSectionTitle | null;
    icon?: Icon | null;
    /**
     * Whether the section should be created in draft mode. Defaults to false. Editors can set this to true to create draft content after sections are enabled. Creating live content requires Creator permission; enabling sections requires Admin permission.
     * @default false
     */
    draft?: boolean;
    /** Custom home page within an existing space, rendered at the section's path root instead of the space's default landing page. Providing it when `spaceId` is `null` returns a 400 error. */
    pageId?: string;
    /** ID of the section group to create the section in */
    siteSectionGroupId?: string;
  };
  RequestHeaders: {};
  ResponseBody: SiteSection & {
    /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
    subscriptionNotice?: SubscriptionNotice;
  };
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/sections",
  method: "post",
  streaming: false,
  tags: ["site-sections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of sections in the site. Each section is a top-level navigation item backed by one or more site spaces. Use this to inspect the current navigation structure, find a section ID before updating it, or check whether sections are in draft or live state.
 * @tags site-sections
 * @name ListSiteSections
 * @summary List all navigation sections in a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/sections
 * @secure
 */

// @ts-ignore
export const listSiteSections: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteSection[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/sections",
  method: "get",
  streaming: false,
  tags: ["site-sections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates a navigation section's configuration in the site structure.
 * @tags site-sections
 * @name UpdateSiteSectionById
 * @summary Update a navigation section in a site
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}
 * @secure
 */

// @ts-ignore
export const updateSiteSectionById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the section within a site */
    siteSectionId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the site section */
    title?: SiteSectionTitle;
    /** Localized string value with a 128 character limit, keyed by locale. Contains overrides for non-default languages only. */
    localizedTitle?: LocalizedString128;
    /** Path to the section on the site */
    path?: SiteSectionPath;
    /** ID of the site-space to be used as the default in this section. */
    defaultSiteSpace?: string;
    /** Whether to hide the site section from the site's navigation. Setting it updates all the site spaces of the section, and site spaces added to a hidden section are hidden too. The default site section cannot be hidden. */
    hidden?: boolean;
    /** Conditional expression used to evaluate whether the site section should be shown to the site's visitor (should evaluate to a boolean). If not set, the condition will remain unchanged. If set to null, the condition will be removed. */
    condition?: Expression | null;
    icon?: Icon | null;
    /** Whether the site section should be kept in draft mode. Setting it to true makes the site section draft. Setting it to false makes the site section live. */
    draft?: boolean;
    description?: SiteSectionDescription | null;
    /** Localized string value with a 256 character limit, keyed by locale. Contains overrides for non-default languages only. */
    localizedDescription?: LocalizedString256;
    /** ID of the section group to move the section into. Set to null to move the section to the root of the site. */
    siteSectionGroupId?: string | null;
  };
  RequestHeaders: {
    /** Control whether a successful response includes the updated resource representation. */
    prefer?: "return=minimal" | "return=representation";
  };
  ResponseBody: SiteSection | undefined;
  ResponseStatusCode: 200 | 204;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}",
  method: "patch",
  streaming: false,
  tags: ["site-sections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-sections
 * @name DeleteSiteSectionById
 * @summary Delete a site section
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}
 * @secure
 */

// @ts-ignore
export const deleteSiteSectionById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the section within a site */
    siteSectionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}",
  method: "delete",
  streaming: false,
  tags: ["site-sections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-sections
 * @name MoveSiteSection
 * @summary Move a site section to a new position. (Deprecated) use sortSiteStructure instead.
 * @request POST:/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}/move
 * @deprecated
 * @secure
 */

// @ts-ignore
export const moveSiteSection: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the section within a site */
    siteSectionId: string;
  };
  RequestQuery: {};
  RequestBody:
    | {
        /** The position where to move the site section. When not provided the site section is moved at the end of the site. */
        position?: SiteSectionMovePosition;
      }
    | undefined;
  RequestHeaders: {};
  ResponseBody: SiteSection;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}/move",
  method: "post",
  streaming: false,
  tags: ["site-sections"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: { errorRate: 0 },
};
